import { render, staticRenderFns } from "./NotesTags.vue?vue&type=template&id=700e3dcb&xmlns%3Av-popover=true&"
import script from "./NotesTags.vue?vue&type=script&lang=js&"
export * from "./NotesTags.vue?vue&type=script&lang=js&"
import style0 from "./NotesTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('700e3dcb')) {
      api.createRecord('700e3dcb', component.options)
    } else {
      api.reload('700e3dcb', component.options)
    }
    module.hot.accept("./NotesTags.vue?vue&type=template&id=700e3dcb&xmlns%3Av-popover=true&", function () {
      api.rerender('700e3dcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/NotesTags.vue"
export default component.exports